import { render } from "./EmailConfirmation.vue?vue&type=template&id=2952cd14&scoped=true"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js"

import "./EmailConfirmation.vue?vue&type=style&index=0&id=2952cd14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2952cd14"]])

export default __exports__